import axios, { Axios } from "axios";

const AxiosClient:Axios = axios.create();


export default AxiosClient;